import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import EDEStatementsPage from "components/EDEStatements/pages/EDEStatementsPage";
import Classes from "model";
import { useEffect } from "react";

export default function CaptureEDEStatements(props) {
    const context = useBCMSContext();

    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <EDEStatementsPage />
}